import 'core-js/stable'

const isServer = typeof window === 'undefined'

// Handle stale Vite asset errors after deploy (cached JS references old hashed CSS/JS).
if (!isServer) {
  window.addEventListener('unhandledrejection', (event) => {
    const message = event.reason?.message
    if (typeof message !== 'string') return

    const isStaleCss = message.startsWith('Unable to preload CSS for ')
    const isStaleJs = message.startsWith('Failed to fetch dynamically imported module: ') && message.includes('/dist/assets/')
    const isImportFailed = message.includes('Importing a module script failed')

    if (isStaleCss || isStaleJs || isImportFailed) {
      event.preventDefault()
      const reloadKey = 'csm-stale-asset-reload'
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1')
        window.location.reload()
      }
    }
  })
}

import { ViteSSG } from 'vite-ssg'
import { createMemoryHistory, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import NProgress from 'nprogress'
import { VueQueryPlugin } from '@tanstack/vue-query'
import sentryPlugin from '@/plugins/sentry'
import vuetifyPlugin from '@/plugins/vuetify'
import gtagPlugin from '@/plugins/gtag'
import csmPlugin from '@csm/template/plugin'
import { useHash } from '@csm/template/composables/useHash'
import App from '@/App.vue'
import '@/styles/app.scss'

export const createApp = ViteSSG(
  App,
  {
    history: isServer
      ? createMemoryHistory()
      : createWebHistory(),
    routes,
    scrollBehavior(to) {
      const { goToHash } = useHash()
      if (to.hash) {
        goToHash(to.hash)
        return
      }
      return { left: 0, top: 0 }
    },
  },
  ({ app, router }) => {
    app.use(VueQueryPlugin)
    app.use(sentryPlugin)
    app.use(vuetifyPlugin)
    app.use(gtagPlugin)
    app.use(csmPlugin)

    if (isServer) {
      return
    }

    const { goToHashOnMounted } = useHash()
    goToHashOnMounted()

    router.beforeResolve((to, from, next) => {
      if (to.name) {
        NProgress.start()
      }
      next()
    })

    router.afterEach(() => {
      NProgress.done()
    })

    window.addEventListener('vite:preloadError', () => {
      window.location.reload()
    })
  },
)
